module.exports = __webpack_public_path__ + "img/Perfect-Match.fb0be2a7.png";